import styled from 'styled-components';
import { useState } from 'react';
import classes from './CustomSelect.module.scss';

export default function CustomTelCode({ listOptions, defaultValue, handleSelect }) {
    const [isOpen, setIsOpen] = useState(false);
    const toggling = () => setIsOpen(!isOpen);

    const [isActive, setIsActive] = useState('isActive');
    const toggleActive = () => setIsActive(!isActive);

    const [selectedOption, setSelectedOption] = useState(null);
    const onOptionClicked = (value) => () => {
        setSelectedOption(value);
        handleSelect({ name: 'countryCode', value: value });
        setIsOpen(false);
        toggleActive();
    };

    return (
        <SelectWrapper className={classes.selectWrapper}>
            <SelectInput
                className={`${classes.mSelectInput} ${classes.telCode} fnt16f`}
                onClick={toggling}
            >
                {selectedOption || defaultValue}
                <figure className={classes.aCaret}>
                    <svg
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1 1L7 7L13 1"
                            stroke="#4F4F4F"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </figure>
            </SelectInput>
            {isOpen && (
                <DropDownList className={classes.mSelectDropdown}>
                    {listOptions.map((option) => (
                        <ListItem
                            className={classes.aSelectItem}
                            onClick={onOptionClicked(option.area_code)}
                            key={Math.random()}
                        >
                            <span>
                                {option.name} | {option.area_code}
                            </span>
                        </ListItem>
                    ))}
                </DropDownList>
            )}
        </SelectWrapper>
    );
}

const SelectWrapper = styled('div')`
    width: 100%;
    margin: 0 auto;
`;
const SelectInput = styled('div')``;
const DropDownList = styled('ul')``;
const ListItem = styled('li')``;
